import React from "react";
import { Image } from "react-bootstrap";

import {
  customerSurveyConstants,
  customerSurveyLabels,
} from "../../../../constants";
import {
  emptyString,
  customerSurveyButtonConstants,
  surveyStylePreviewConstants,
  wizardDummyDataConstants,
} from "../../../../views/shared-screens/constants";

const {
  CUSTOMER_NAME: sampleCustomerName,
  EMAIL: sampleEmail,
  ORDER_ID: sampleOrderId,
} = wizardDummyDataConstants;
const { CUSTOMER_NAME, EMAIL, ORDER_ID } = customerSurveyLabels;
const { NEXT, BACK } = customerSurveyButtonConstants;
const {
  EXPERIENCE_QUESTION,
  FILLED_STARS,
  EMPTY_STAR,
  PROGRESS_VALUE,
  PROGRESS_MIN,
  PROGRESS_MAX,
  LOGO_ALT,
} = surveyStylePreviewConstants;

const SurveyStyleLogo = ({ brand, logoWrapClassName, themeLogoFluid }) => {
  return (
    <div className="col-12 d-flex justify-content-center align-items-center survey-logo mb-4 py-3">
      {brand?.logoTheme && brand.logoTheme !== emptyString ? (
        <div className={logoWrapClassName}>
          <Image
            alt={LOGO_ALT}
            src={brand.logoTheme}
            {...(themeLogoFluid ? { fluid: true } : {})}
            className="survey-theme-logo"
          />
        </div>
      ) : (
        <Image
          alt={LOGO_ALT}
          src={brand?.logoURL}
          fluid
          width={customerSurveyConstants.SURVEY_LOGO_WIDTH_PX}
        />
      )}
    </div>
  );
};

const SurveyStyleCustomerInfo = ({
  customerInfoColClass,
  customerInfoBorderClass,
}) => {
  return (
    <div className="me-0 col-12 row">
      <div className="d-flex justify-content-center col">
        <div className={` text-center mt-2 customer-info ${customerInfoColClass}`}>
          <div className={` border ${customerInfoBorderClass} px-2 rounded`}>
            <p aria-label="customer-name">
              <span className="fw-bold">{CUSTOMER_NAME}</span>
              <span className="fw-light">{sampleCustomerName}</span>
            </p>
            <p aria-label="customer-email">
              <span className="fw-bold">{EMAIL}</span>
              <span className="fw-light">{sampleEmail}</span>
            </p>
            <p aria-label="customer-order-id">
              <span className="fw-bold">{ORDER_ID}</span>
              <span className="fw-light">{sampleOrderId}</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

const SurveyStyleQuestion = () => {
  return (
    <>
      <div className=" dynamic-font-color text-center pb-2 mt-4 pt-4 text-wrap ">
        <h4>{EXPERIENCE_QUESTION}</h4>
      </div>
      <div>
        <div>
          <h1 className="ranking-star px-2">
            {FILLED_STARS}
            <span className="white-star px-2">{EMPTY_STAR}</span>
          </h1>
        </div>
      </div>
    </>
  );
};

const SurveyStyleFooter = ({
  footerRowClass,
  buttonColClass,
  buttonExtraClass,
  progressColClass,
}) => {
  return (
    <div className={`container-fluid row ${footerRowClass}`}>
      <div className="col-md-12">
        <div className={`mx-auto mt-2 pb-1 px-2 ${buttonColClass}`}>
          <button
            className={`text-white next-button border-0 rounded h6 ${buttonExtraClass}`.trim()}
            type="submit"
          >
            {NEXT}
          </button>
        </div>
      </div>
      <div className="col-md-12">
        <div
          className={`mx-auto pb-1 px-2 d-flex justify-content-center ${buttonColClass}`}
        >
          <button
            className={`back-button border-0 rounded h6 mb-0 ${buttonExtraClass}`.trim()}
            type="submit"
          >
            {BACK}
          </button>
        </div>
      </div>
      <div className="col-12 d-flex justify-content-center mt-1">
        <div className={`${progressColClass} progress`}>
          <div
            className="progress-bar"
            role="progressbar"
            aria-valuenow={PROGRESS_VALUE}
            aria-valuemin={PROGRESS_MIN}
            aria-valuemax={PROGRESS_MAX}
          />
        </div>
      </div>
    </div>
  );
};

const SurveyStylePreview = ({ brand, layout }) => {
  return (
    <div className={layout.rootClassName}>
      <SurveyStyleLogo
        brand={brand}
        logoWrapClassName={layout.logoWrapClassName}
        themeLogoFluid={layout.themeLogoFluid}
      />
      <SurveyStyleCustomerInfo
        customerInfoColClass={layout.customerInfoColClass}
        customerInfoBorderClass={layout.customerInfoBorderClass}
      />
      <SurveyStyleQuestion />
      <SurveyStyleFooter
        footerRowClass={layout.footerRowClass}
        buttonColClass={layout.buttonColClass}
        buttonExtraClass={layout.buttonExtraClass}
        progressColClass={layout.progressColClass}
      />
    </div>
  );
};

export default SurveyStylePreview;
